
import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';

@Component({
  selector: 'app-learning-book-title',
  templateUrl: './learning-book-title.component.html',
  styleUrls: ['./learning-book-title.component.css']
})
export class LearningBookTitleComponent implements OnInit {
  Submitted:boolean = false;
  BookTitleList=[];

  constructor(private learningservice:LearningService,private LookupService: LookupService, private globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    LearningModel = {    
      BookTitleID: 0,
      BookTitle: '',
      Publisher: '',
      Edition: '',
      Author: '',
      IsActive: true,
      CurrentIndex: 0,
      PageSize: 20,
  };

  Clear() {
    this.LearningModel.BookTitleID = 0;
    this.LearningModel.BookTitle = '';
    this.LearningModel.Publisher = '';
    this.LearningModel.Edition = '';
    this.LearningModel.Author = '';
    this.LearningModel.IsActive = true;
    this.Submitted = false;
}

Edit(obj) {
  this.LearningModel.BookTitleID = obj.BookTitleID;
  this.LearningModel.BookTitle = obj.BookTitle;
  this.LearningModel.Publisher = obj.Publisher;
  this.LearningModel.Edition = obj.Edition;
  this.LearningModel.Author = obj.Author;
  this.LearningModel.IsActive = obj.IsActive;

}

ValidityState(){
  return this.LearningModel.BookTitle=='';
}


SaveLearningBookTitle() {  
  this.Submitted = true;
  if (!this.ValidityState()) {
    this.spinnerService.show();
    this.learningservice.SaveLearningBookTitle(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllLearningBookTitle();
      }
      if (data.webResponse.Status && this.LearningModel.BookTitleID == 0) {
        this.Clear();
      }
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  }

};

GetAllLearningBookTitle() {
  this.spinnerService.show();
  this.LearningModel.CurrentIndex = this.currentPage;
  this.LearningModel.PageSize = this.pageSize;
  this.learningservice.GetAllLearningBookTitle(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
    this.BookTitleList = data.BookTitleList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
    this.recordCount = 0;
    if (data.BookTitleList != null && data.BookTitleList.length > 0) {
        this.recordCount = data.BookTitleList[0].RecordCount;
    }
    this.numberOfPages();
  });
};

MarkActiveLearningBookTitle(item) {
  this.LearningModel.BookTitleID = item.BookTitleID;
  this.LearningModel.IsActive = item.IsActive == true ? false : true;
  this.spinnerService.show();
  this.learningservice.MarkActiveLearningBookTitle(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
    if (data.webResponse.Status) {
      this.GetAllLearningBookTitle();
    }
   
    this.globalHelper.CheckActionStatus(data);
    this.spinnerService.hide();
  });
};
  ngOnInit() {
    this.GetAllLearningBookTitle();
  }


  // Paging

  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages() {
   this.totalPages = Math.ceil(this.recordCount / this.pageSize);
   }

   nextPage() {
   this.currentPage = this.currentPage + 1;
   }

   pageSizes() {
   this.currentPage = 1;
   this.recordCount = 0;
   this.totalPages = 0;
   }



}

